import React from "react";
import { useState } from "react";
import {
  Transaction_Book,
  Transaction_Forum,
} from "../../Connections/Transaction";

import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import Toast from "../../Utils/Toast";

import "../../Styles/NewComment.css";
import { useNavigate } from "react-router";

const NewComment = (props) => {
  const navigate = useNavigate();

  //  ==================================================

  const [showclickButton, setShowclickButton] = useState(false);

  const [comment, setCommment] = useState();
  const [loading, setLoading] = useState(false);
  const [replayText, setReplayText] = useState();
  const [replayModal, setReplayModal] = useState(false);
  const [replayLoading, setReplayLoading] = useState(false);
  const [reportBox, setReportBox] = useState(false);
  const [reporText, setReporText] = useState();
  //  ==================================================

  const handleRateComment = (rate) => {
    if (props.book.isProfileComplete) {
      Transaction_Forum.AddPostRate({
        postId: props.comment.id,
        rate: rate,
      })
        .then((res) => {
          if (res[0]) {
            Toast("success", "نظرت با موفقیت ثبت شد!");
            props.getLastPost();
          }
        })
        .catch((err) => console.log(err));
    } else {
      Toast("warning", "اول اطلاعات پروفایلت رو تکمیل کن!");
    }
  };

  const handleLikeComment = (type) => {
    Transaction_Forum.AddPostLike({
      ForumPostId: props.comment.id,
      Type: type,
    }).then((res) => {
      if (res[0]) {
        Toast("success", "ری‌اکشنت ثبت شد!");
        props.getLastPost();
      }
    });
  };

  const handleReplayComment = () => {
    if (props.book.isProfileComplete) {
      if (replayText) {
        setReplayLoading(true);
        Transaction_Forum.AddComment({
          comment: replayText,
          forumPostId: props.comment.id,
        })
          .then((res) => {
            if (res[0]) {
              setReplayLoading(false);
              setReplayText("");
              setReplayModal(false);
              Toast("success", "جوابت با موفقیت ثبت شد!");
              props.getLastPost();
            } else Toast("error", res[1]);
          })
          .catch((err) => {
            console.log(err);
            setReplayLoading(false);
          });
      } else {
        Toast("error", "اول جوابت رو بنویس.");
      }
    } else {
      Toast("error", "اول اطلاعات پروفایلت رو تکمیل کن!");
      navigate("/profile");
    }
  };

  const handleSubmitSendCommentForm = (e) => {
    e.preventDefault();

    if (!props.book.isComment) {
      if (comment) {
        const data = { text: comment, bookId: props.book.id };
        setLoading(true);
        Transaction_Book.AddBookComment(data)
          .then((res) => {
            setLoading(false);
            if (res[0]) {
              setCommment("");
              Toast("success", "نظرت با موفقیت ثبت شد.");
              props.getLastPost();
              props.getBook();
            } else {
              if (res[1] == "Please log in first") {
                Toast("error", " ابتدا وارد شوید یا ثبت نام کنید ");
              } else {
                console.log("error");
                Toast("error", res[1]);
              }
            }
          })
          .catch((err) => {
            setLoading(false);
            Toast("error", "مشکلی پیش آمده است! دوباره سعی کن");
          });
      } else {
        Toast("error", "اول نظر خودت رو بنویس بعد ثبت کن.");
      }
    } else {
      Toast("info", "قبلا راجب این کتاب نظر ثبت کردی!");
    }
  };

  const handelPostReport = (text, id) => {
    const data = { text: text, forumPostId: id };
    Transaction_Forum.AddPostReport(data).then((res) => {
      if (res[0]) {
        Toast("success", "گزارش شما ثبت شد");
      } else {
        Toast("error", "مشکلی پیش آمده لطفا دوباره تلاش کنید");
      }
      setReportBox(false);
    });
  };
  //  ==================================================

  const comentId = props?.comment?.id;
  const userId = props?.comment?.userId;
  const bookId = props?.book?.id;

  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
    Toast("success", "لینک با موفقیت برای اشتراک گذاری کپی شد!");
  };
  console.log(props?.comment);
  return (
    <div className="NewComment_wrapper">
      {replayModal ? (
        <div className="modal-wrapper">
          <div className="NewComment_replay-comment-box">
            <h4>جواب خودت رو بهش بنویس</h4>
            <div className="input-group">
              <label htmlFor="replay-input">اینجا بنویس:</label>
              <textarea
                id="replay-input"
                value={replayText}
                rows="6"
                onChange={(e) => setReplayText(e.target.value)}
              ></textarea>
            </div>
            <div className="NewComment_replay-btns-wrapper">
              <button onClick={handleReplayComment} className="sendModalBtn">
                {replayLoading ? <LoadingSpinner /> : "ارسال"}
              </button>
              <button
                onClick={() => setReplayModal(!replayModal)}
                className="closeModalBtn"
              >
                بیخیال
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {reportBox ? (
        <div className="modal-wrapper">
          <div className="report-box">
            <div className="report">
              <img src="/imgs/Book/Gozaresh.svg" />
            </div>
            <div className="report-box-inside">
              <h4>چرا فکر می‌کنی این پست مشکل داره؟</h4>
              <div className="input-group">
                <label className="report-box-label" htmlFor="replay-input">
                  برامون بنویس:
                </label>
                <textarea
                  id="replay-input"
                  value={reporText}
                  rows="6"
                  onChange={(e) => setReporText(e.target.value)}
                ></textarea>
              </div>
              <div className="NewComment_replay-btns-wrapper">
                <button
                  onClick={() =>
                    handelPostReport(reporText, props?.comment?.id)
                  }
                  className="sendModalBtn"
                >
                  {replayLoading ? <LoadingSpinner /> : "ارسال"}
                </button>
                <button
                  onClick={() => setReportBox(!reportBox)}
                  className="closeModalBtn"
                >
                  بیخیال
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="NewComment_part1">
        <h3 className="NewComment_part1-text">نظر کارشناسی خودت رو بنویس:</h3>
      </div>
      <form
        onSubmit={handleSubmitSendCommentForm}
        style={
          props.book.isComment ? { pointerEvents: "none", opacity: ".5" } : null
        }
      >
        <div className="NewComment_part2">
          <textarea
            value={comment}
            placeholder="نظرت رو اینجا بنویس"
            onChange={(e) => setCommment(e.target.value)}
            className="NewComment_part2-comment number-font"
          ></textarea>
        </div>
        <div className="NewComment_part3">
          <button
            disabled={loading}
            type="submit"
            className="NewComment_part3-button"
          >
            {loading ? <LoadingSpinner /> : "ثبت نظر"}
          </button>
        </div>
      </form>
      <div className="NewComment_part4">
        <div className="NewComment_part4-comment">
          <div className="NewComment_part4-comment-item1">
            <div className="NewComment_part4-comment-item1-right">
              <img
                className="NewComment_part4-comment-item1-right-image"
                style={{ maxWidth: 30 }}
                src={props.comment?.avatar}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = "/imgs/Book/Seke.svg";
                }}
              />
              <p className="NewComment_part4-comment-item1-right-name">
                {props.comment?.name}
              </p>
            </div>
            <div className="NewComment_part4-comment-item1-left">
              <div className="NewComment_part4-comment-item1-left-border">
                <button
                  className="NewComment_part4-comment-item1-left-border-button"
                  onClick={() => setShowclickButton(!showclickButton)}
                >
                  ...
                </button>
              </div>
              {showclickButton ? (
                <div className="NewComment-clickButton">
                  <div className="NewComment-clickButton-inside">
                    <div
                      className="NewComment-clickButton-inside-top"
                      onClick={() =>
                        props.book.isProfileComplete
                          ? setReportBox(!reportBox)
                          : Toast("warning", "اول پروفایلت رو کامل کن!")
                      }
                    >
                      <img
                        className="MyBook-inside-item2-Book-bottom-clickButton-inside-top-img"
                        src="/imgs/comment/t.svg"
                      />
                      <p className="NewComment-clickButton-inside-top-text">
                        گزارش تخلف
                      </p>
                    </div>
                    {/* <div className="NewComment-clickButton-inside-top">
                      <img
                        className="MyBook-inside-item2-Book-bottom-clickButton-inside-top-img"
                        src="/imgs/comment/save.svg"
                      />
                      <p className="NewComment-clickButton-inside-top-text">
                        ذخیره
                      </p>
                    </div> */}
                    <div className="NewComment-clickButton-inside-bottom">
                      <img
                        className="MyBook-inside-item2-Book-bottom-clickButton-inside-bottom-img"
                        src="/imgs/Profile/shareBook.svg"
                      />
                      <p
                        onClick={() =>
                          copyToClipBoard(
                            // `https://ketabno.com/hisstori/blog/${userId}/user/${actionId}/action/0#${comentId}`
                            `https://ketabno.com/hisstori/blog/${userId}/user/${bookId}/action/0#${comentId}`
                          )
                        }
                        className="NewComment-clickButton-inside-bottom-text"
                      >
                        اشتراک گذاری
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="NewComment_part4-comment-item2">
            <div className="NewComment_part4-comment-item2-right">
              <div className="NewComment_part4-comment-item2-right-emoji">
                <img
                  className={`NewComment_part4-comment-item2-right-emoji-img ${
                    props.comment?.rate == 1 ? "active" : null
                  }`}
                  src="/imgs/Book/em1.png"
                />
                <img
                  className={`NewComment_part4-comment-item2-right-emoji-img ${
                    props.comment?.rate == 2 ? "active" : null
                  }`}
                  src="/imgs/Book/em2.png"
                />
                <img
                  className={`NewComment_part4-comment-item2-right-emoji-img ${
                    props.comment?.rate == 3 ? "active" : null
                  }`}
                  src="/imgs/Book/em3.png"
                />
                <img
                  className={`NewComment_part4-comment-item2-right-emoji-img ${
                    props.comment?.rate == 4 ? "active" : null
                  }`}
                  src="/imgs/Book/em4.png"
                />
                <img
                  className={`NewComment_part4-comment-item2-right-emoji-img ${
                    props.comment?.rate == 5 ? "active" : null
                  }`}
                  src="/imgs/Book/em5.png"
                />
              </div>
            </div>
            <div className="NewComment_part4-comment-item2-left">
              <div className="NewComment_part4-comment-item2-left-time number-font">
                {props.comment?.dateTime}
              </div>
            </div>
          </div>

          <div className="NewComment_part4-comment-item3">
            <p
              className="NewComment_part4-comment-item3-comment number-font"
              style={{ padding: 10 }}
            >
              {props.comment?.text}
            </p>
          </div>
          <div className="NewComment_part4-comment-item4">
            <div className="NewComment_part4-comment-item4-right">
              <div className="NewComment_part4-comment-item4-right-button">
                <button
                  className="NewComment_part4-comment-item4-right-button-like"
                  onClick={() => handleLikeComment(1)}
                >
                  <img
                    className="NewComment_part4-comment-item4-right-button-like-svg"
                    src="/imgs/Book/Like.svg"
                  />
                  <p className="NewComment_part4-comment-item4-right-button-like-number">
                    {props.comment?.like}
                  </p>
                </button>
                <button
                  className="NewComment_part4-comment-item4-right-button-dislike"
                  onClick={() => handleLikeComment(2)}
                >
                  <img
                    className="NewComment_part4-comment-item4-right-button-dislike-svg"
                    src="/imgs/Book/DisLike.svg"
                  />
                  <p className="NewComment_part4-comment-item4-right-button-dislike-number">
                    {props.comment?.disLike}
                  </p>
                </button>
              </div>
            </div>
            <div className="NewComment_part4-comment-item4-left">
              <div
                className="NewComment_part4-comment-item4-left-reply"
                onClick={() =>
                  props.book.isProfileComplete
                    ? setReplayModal(!replayModal)
                    : Toast("warning", "اول پروفایلت رو کامل کن!")
                }
              >
                <p className="NewComment_part4-comment-item4-left-reply-text">
                  بهش جواب بده
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                  >
                    <path
                      d="M3.33105 0.4375L0.487305 3.6875L3.33105 6.9375M0.487305 3.6875H6.58105C9.83105 3.6875 11.4561 5.3125 11.4561 8.5625"
                      stroke="#09D4FF"
                      strokeWidth="0.8125"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </p>
              </div>
            </div>
          </div>

          <div className="NewComment_part4-comment-item5">
            <button
              className="NewComment_part4-comment-item5-button"
              onClick={() =>
                navigate(`/hisstori/blog/${props.book.id}/action`, {
                  state: { actionId: 5 },
                })
              }
            >
              <span className="number-font">
                {" "}
                {props.comment?.comments.length}{" "}
              </span>
              جواب به این پیام داده شده
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewComment;
